import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight } from "react-icons/fa";
// ATTENTION!!!!!!!!!!
// I SWITCHED TO PERMANENT DOMAIN
const url = "https://course-api.com/react-tabs-project";
function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [tabs, setTabs] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  const getTabs = async () => {
    try {
      const response = await fetch(url);
      const newTabs = await response.json();
      console.log(newTabs);
      setTabs(newTabs);
      setIsLoading(false);
    } catch (e) {
      console.error(e.message);
    }
  };

  useEffect(() => {
    getTabs();
  }, []);

  if (isLoading) {
    return (
      <section className="section loading">
        <h1> LOADING...</h1>
      </section>
    );
  }

  // DESTRUCTURE HERE AND NOT IN THE RETURN STATEMENT. tabs[tabIndex] in return iS BUGGY!
  const { company, dates, duties, title } = tabs[tabIndex];

  return (
    <>
      <main className="section">
        <h1 className="title">Experience</h1>
        <div className="underline"></div>

        <div className="jobs-center">
          <div className="btn-container">
            {tabs.map((tab, index) => {
              return (
                <button
                  key={index}
                  // check out this trick below for seeing active or not buttons.
                  className={`job-btn ${tabIndex === index && "active-btn"}`}
                  onClick={() => {
                    setTabIndex(index);
                  }}
                >
                  {tab.company}
                </button>
              );
            })}
          </div>

          <div className="job-info">
            <h3>{title}</h3>
            <h4>{company}</h4>
            <p className="job-date">{dates}</p>
            {duties.map((duty, index) => {
              return (
                <div key={index} className="job-desc">
                  <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
                  <p>{duty}</p>
                </div>
              );
            })}
          </div>
        </div>
      </main>
    </>
  );
}

export default App;
